import React, { Component, Fragment } from "react";
import PropTypes from "prop-types";
import { toJS } from "mobx";
import { observer, inject } from "mobx-react";
// eslint-disable-next-line import/no-extraneous-dependencies
import { pageType } from "npmlinks-constants";
import {
  GridContainer,
  GridRow,
  GridColumn,
  Utils,
  Modal
} from "arv-reactcomponents";
import {
  setPageType,
  queryParamsToObject,
  somethingWentWrong,
  getCurrentHref,
  cacheQueryParser,
  HTMLUtils,
  validateUrlforMalform
} from "../../utils";
import { MobileFilterContainer } from "../../component/MobileFilters";
import ProductFilters from "../../component/ProductFilters";
import ProductList from "../../component/ProductList";
import ProductListTopbar from "../../component/ProductListTopbar";
import BodyOverlay from "../../component/BodyOverlay";
import Analytics from "../../analytics";
import GTM from "../../analytics/GTM";
import Event from "../../analytics/eventFactory";
import ProductListingBanner from "../../component/ProductList/ProductListingBanner";
import OmniView from "../../component/OmniView";
import StickyFilterBlock from "../../component/ProductFilters/StickyFilterBlock";
import MobileFilterButtons from "../../component/MobileFilters/MobileFilterButton";
import BreadcrumbList from "../../component/BreadcrumbList";

const INFINITE_SCROLL_OFFSET = 2000;

@inject("GetTypeStore", "ProductStore", "FooterStore", "CommonStore")
@observer
class Listing extends Component {
  static removeBodyScrollHeight() {
    document.querySelector(".nw-app-body").style.minHeight = null;
  }

  static windowLocation() {
    const { pathname } = window.location;
    let { search } = window.location;
    search = HTMLUtils.sanitizeHTML(search);
    return `${pathname}${search}`;
  }

  static trackPageNumber(pageNo) {
    Analytics.trackEvent({
      action: Event.action.getListPageNo(pageNo),
      label: Event.label.getSource(window.pageType),
      category: Event.category.LISTING_PAGE
    });
  }

  static decidePageType() {
    const pagePath = window.location.pathname;
    const pageUrl = getCurrentHref();
    const searchUrls = [`/${Event.category.SEARCH}`];
    const isSearchPage = searchUrls.includes(pagePath);
    return isSearchPage
      ? `${Event.category.SEARCH}_${pageUrl}`
      : `${Event.category.LISTING_PAGE}_${pageUrl}`;
  }
  static returnCurrentCollectionId(props) {
    const collectionIdFromWindowState =
      (window &&
        window.history &&
        window.history.state &&
        window.history.state.state &&
        window.history.state.state.collectionId) ||
      "";
    const collectionIdFromProps = props.ProductStore.collectionId;
    return collectionIdFromProps || collectionIdFromWindowState;
  }
  static returnCurrentType(props) {
    const typeFromWindowState =
      (window &&
        window.history &&
        window.history.state &&
        window.history.state.state &&
        window.history.state.state.type) ||
      "";
    const typeFromProps = props.ProductStore.type;
    return typeFromProps || typeFromWindowState;
  }

  constructor(props) {
    super(props);

    const { isDesktop } = this.props.CommonStore;
    this.filterBlockClass = isDesktop ? "" : "nw-filterblock-container";
    this.state = {
      omniView: false
    };
    this.currentPageStats = {
      currentPage: pageType.listing,
      collectionId: Listing.returnCurrentCollectionId(props),
      type: Listing.returnCurrentType(props)
    };
    this.removeScrollListener = Utils.noop;
    this.removePopStateListener = Utils.noop;
    this.setProductListRef = this.setProductListRef.bind(this);
    this.maintainScroll = this.maintainScroll.bind(this);
    this.initInfiniteScroll = this.initInfiniteScroll.bind(this);
    this.isListingScrollAtBottom = this.isListingScrollAtBottom.bind(this);
    this.updatePageNumber = this.updatePageNumber.bind(this);
    this.initialData = this.initialData.bind(this);
    this.refreshData = this.refreshData.bind(this);
    this.storeScrollInState = this.storeScrollInState.bind(this);
    this.triggerListingAfterOmni = this.triggerListingAfterOmni.bind(this);
    this.initializeListing = this.initializeListing.bind(this);
    this.initializeOmni = this.initializeOmni.bind(this);
    this.handleOldFilters = this.handleOldFilters.bind(this);

    // @TODO: Remove this once serviceworker solution implemented
    this.setListingGettypeData = this.setListingGettypeData.bind(this);
    this.setBreadcrumb = this.setBreadcrumb.bind(this);
    this.clearBreadcrumb = this.clearBreadcrumb.bind(this);
    // @TODO: Remove this once serviceworker solution implemented

    this.handleGoogleCache = this.handleGoogleCache.bind(this);
    this.filterBlock = (!isDesktop && MobileFilterButtons) || StickyFilterBlock;
  }
  componentDidMount() {
    const isGoogleCache = this.handleGoogleCache();

    if (isGoogleCache) {
      return;
    }

    this.handleOldFilters();
    this.initializeListing();
    this.initializeOmni();

    // @TODO: Remove this once serviceworker solution implemented
    this.setListingGettypeData();
    this.setBreadcrumb();
    // @TODO: Remove this once serviceworker solution implemented
  }

  componentWillUnmount() {
    this.removeScrollListener();
    this.removePopStateListener();
    this.props.ProductStore.toggleFilterView(false);
    this.props.FooterStore.changeFooterVisibleState(true);
    Listing.removeBodyScrollHeight();

    // @TODO: Remove this once serviceworker solution implemented
    this.clearBreadcrumb();
    // @TODO: Remove this once serviceworker solution implemented
  }

  get isScrollAtBottom() {
    return `${this.isListingScrollAtBottom()}`;
  }

  // @TODO: Remove this once serviceworker solution implemented
  setListingGettypeData() {
    const { GetTypeStore, location } = this.props;
    const { listingData } = GetTypeStore;
    const { pathname } = location;

    if (!listingData[pathname]) {
      GetTypeStore.setListingData(pathname, GetTypeStore.data);
    }
  }

  setBreadcrumb() {
    const { GetTypeStore, location } = this.props;
    const { listingData } = GetTypeStore;
    const { pathname } = location;

    GetTypeStore.setGetTypeData(listingData[pathname]);
  }

  setProductListRef(context) {
    this.ProductListRef = context;
  }

  clearBreadcrumb() {
    const { GetTypeStore, location } = this.props;
    const { listingData } = GetTypeStore;
    const { pathname } = location;

    if (listingData[pathname]) {
      GetTypeStore.setGetTypeData({});
    }
  }
  // @TODO: Remove this once serviceworker solution implemented

  initializeOmni() {
    const { search } = this.props.location;
    const queryObj = queryParamsToObject(search);
    if (queryObj.when) {
      this.setState({
        omniView: true,
        omniViewType: queryObj.when
      });
    }
  }
  initializeListing() {
    const { ProductStore, FooterStore } = this.props;
    const { ProductData = {} } = ProductStore;
    const items = ProductData && ProductData.styles && ProductData.styles.styleList && ProductData.styles.styleList.length ? ProductData.styles.styleList : {};
    Listing.removeBodyScrollHeight();
    this.storeScrollInState(Listing.windowLocation());
    if (ProductStore.ProductData === null) {
      this.initialData();
    } else {
      this.initInfiniteScroll();
    }
    this.handleBrowserBack();
    ProductStore.toggleFilterView(true);
    FooterStore.changeFooterVisibleState(false);
    setPageType(pageType.listing);
    Analytics.pageView(window.pageType);
    Analytics.trackEvent({
      action: Event.action.LANDED,
      category: Event.category.LISTING_PAGE,
      label: Listing.decidePageType(),
      interaction: true
    });
    
    if (items && items.length) {
      let gaStyleData = items.map((item, index) => {
        return {
          item_id: item.id,
          item_name: item.name,
          coupon:
            item.promotions && item.promotions.length
              ? toJS(item.promotions)
              : "",
          currency: "INR",
          discount: item.discountRange && item.discountRange.max,
          index: index,
          item_brand: item.brand,
          price: item.sellingPriceRange && item.sellingPriceRange.max
        };
      });

      let ecommObj = {
        items: gaStyleData
      }
      
      GTM.pushObject({
        "ecommerce": ecommObj,
        "event": Event.GTMEvent.VIEW_ITEM_LIST,
      });
    }
    GTM.pushEvent(Event.GTMEvent.LISTING);
    GTM.pushEvent(Event.GTMEvent.ADWORDS);
  }

  handleGoogleCache() {
    let search = this.props.location.search;
    if (search) {
      search = validateUrlforMalform(search);
    }
    const pathToReload = cacheQueryParser(search).replace(/\+\&/, "?&");

    if (pathToReload) {
      window.location.href = pathToReload;
      return true;
    }

    return false;
  }

  handleOldFilters() {
    const { pathname, search } = window.location;
    let queryParam = search;
    queryParam = HTMLUtils.sanitizeHTML(queryParam);
    queryParam = queryParam.replace(/\bat\b/, "category");
    queryParam = queryParam.replace(/\bf-ge\b/, "gender");
    queryParam = queryParam.replace(/\bf-br\b/, "brand");

    this.props.history.replace(
      `${pathname}${queryParam}`,
      this.currentPageStats
    );
  }

  triggerListingAfterOmni(newUrl) {
    this.setState({
      omniView: false
    });
    if (newUrl) {
      this.storeScrollInState(newUrl);
      this.props.ProductStore.clearProductData();
      this.initializeListing();
    }
  }
  handleBrowserBack() {
    const onPopState = () => {
      if (Modal.isModalOpen()) {
        return;
      }

      this.initialData();
    };
    window.addEventListener("popstate", onPopState);
    this.removePopStateListener = () => {
      window.removeEventListener("popstate", onPopState);
    };
  }

  maintainScroll() {
    const { location } = this.props;
    if (!location.state) {
      return;
    }
    document.querySelector(
      ".nw-app-body"
    ).style.minHeight = `${location.state.height}px`;
  }

  initInfiniteScroll() {
    const { ProductStore } = this.props;

    const infiniteScrollFn = () => {
      if (this.isListingScrollAtBottom() && ProductStore.isHavingMoreProducts) {
        if (!ProductStore.isFetchingData) {
          this.updatePageNumber();
          this.refreshData();
        }
      }

      if (this.ProductListRef && this.ProductListRef.wrappedInstance) {
        this.ProductListRef.wrappedInstance.triggerChange();
      }
    };

    this.removeScrollListener = Utils.onElementScroll(
      window,
      infiniteScrollFn,
      { passive: true }
    );
  }

  isListingScrollAtBottom() {
    if (!this.listRef) {
      return false;
    }

    const windowScrollVals = Utils.windowScroll();
    const elementVals = Utils.getBoundClientRect(this.listRef);

    if (elementVals.bottom - INFINITE_SCROLL_OFFSET < windowScrollVals.bottom) {
      return true;
    }

    return false;
  }

  updatePageNumber() {
    const { ProductStore } = this.props;
    const newPageNo = ProductStore.listingPageNo + 1;

    ProductStore.setListingPageNo(newPageNo);

    Listing.trackPageNumber(newPageNo);
    Analytics.pageView(window.pageType);
  }

  storeScrollInState(url) {
    this.props.history.replace(url, {
      height: Utils.getBoundClientRect(document.querySelector(".nw-app-body"))
        .height,
      ...this.currentPageStats
    });
  }

  initialData() {
    const { ProductStore } = this.props;

    const pagePath = Listing.windowLocation();
    const pathWithPageNo = Utils.setUrlParameter(
      pagePath,
      "p",
      ProductStore.listingPageNo
    );

    BodyOverlay.component.show();
    ProductStore.getAllProductData(pathWithPageNo).then(
      () => {
        this.initInfiniteScroll();
        Listing.removeBodyScrollHeight();
        BodyOverlay.component.hide();
        this.storeScrollInState(Listing.windowLocation());
      },
      () => {
        BodyOverlay.component.hide();
        somethingWentWrong();
      }
    );
  }

  refreshData() {
    const { ProductStore } = this.props;
    const pagePath = Listing.windowLocation();
    const pathWithPageNo = Utils.setUrlParameter(
      pagePath,
      "p",
      ProductStore.listingPageNo
    );
    if (ProductStore.listingPageNo === 1) {
      BodyOverlay.component.show("nw-listingpage-transparentloader");
    }
    ProductStore.getPageData(pathWithPageNo).then(
      (data) => {
        this.storeScrollInState(Listing.windowLocation());
        BodyOverlay.component.hide();
        let styleList = data && data.styles && data.styles.styleList && data.styles.styleList.length ? data.styles.styleList : [];
        let listingDataGA = styleList.map((item,index) => {
          return {
            item_id: item.id,
            item_name: item.name,
            coupon: item.promotions && item.promotions.length ? item.promotions[0].name : "" ,
            currency: "INR",
            discount: item.discountRange && item.discountRange.max,
            index: index,
            item_brand: item.brand,
            price: item.sellingPriceRange && item.sellingPriceRange.max
          };
        });
        let ecommObj = {
          items: listingDataGA
        }
       
        GTM.pushObject({
          ecommerce: ecommObj,
          event: Event.GTMEvent.VIEW_ITEM_LIST
        });
      },
      () => {
        somethingWentWrong();
        BodyOverlay.component.hide();
      }
    );
  }

  render() {
    const { omniView, omniViewType } = this.state;
    const { ProductStore, CommonStore, location } = this.props;
    const { isDesktop } = CommonStore;
    const { bannerDetails, isHavingMoreProducts, ProductData, type } = ProductStore;
    const ProductDataObj = toJS(ProductData);
    const pathName = window.location.pathname && window.location.pathname.split("/") || "";
    const pcatName = pathName && pathName.length && pathName[1] || "";
    if (
      ProductDataObj &&
      ProductDataObj.styles &&
      ProductDataObj.styles.styleList
    ) {
      type == "Collection"
        ? (window.google_tag_params = {
            ecomm_pagetype: Event.GTMEvent.ECOMM_LISTING,
            ecomm_prodid: ProductDataObj.styles.styleList
              .slice(0, 5)
              .map(el => el.id),
            ecomm_pcat: [pcatName]
          })
        : (window.google_tag_params = {
            ecomm_pagetype: Event.GTMEvent.ECOMM_LISTING,
            ecomm_prodid: ProductDataObj.styles.styleList
              .slice(0, 5)
              .map(el => el.id)
          });
    }
    if (ProductDataObj && !omniView) {
      return (
        <Fragment>
          <BodyOverlay.component />
          <div className={this.filterBlockClass}>
            <this.filterBlock.component />
          </div>
          {!isDesktop && <BreadcrumbList.component />}
          <GridContainer className="nw-listingpage-container">
            <GridRow>
              {(isDesktop && ProductDataObj.totalElements > 0 && (
                <GridColumn className="nwc-grid-col-xs nw-listingpage-filters">
                  <ProductFilters.component filters={ProductDataObj.filters} />
                </GridColumn>
              )) ||
                null}
              <GridColumn className="nwc-grid-col-xs nw-listingpage-list">
                <div
                  ref={context => {
                    this.listRef = context;
                  }}
                >
                  <ProductListTopbar.component />
                  {bannerDetails && (
                    <div className="nw-listingpage-banner">
                      <ProductListingBanner.component data={bannerDetails} />
                    </div>
                  )}
                  <ProductList.component
                    ref={this.setProductListRef}
                    list={ProductDataObj.styles.styleList}
                    totalElements={ProductDataObj.totalElements}
                    hasMoreProducts={isHavingMoreProducts}
                    isAllPromotions={ProductDataObj.isPromotionsApplied}
                  />
                </div>
              </GridColumn>
            </GridRow>
            <MobileFilterContainer.component />
          </GridContainer>
        </Fragment>
      );
    } else if (omniView) {
      return (
        <OmniView.component
          isOpen={omniView}
          onClose={this.triggerListingAfterOmni}
          ProductStore={ProductStore}
          type={omniViewType}
          location={location}
        />
      );
    }
    return <BodyOverlay.component />;
  }
}

Listing.wrappedComponent.propTypes = {
  location: PropTypes.shape({
    pathname: PropTypes.string.isRequired,
    search: PropTypes.string.isRequired,
    state: PropTypes.object
  }).isRequired,
  history: PropTypes.shape({
    replace: PropTypes.func.isRequired
  }).isRequired,
  GetTypeStore: PropTypes.shape({
    data: PropTypes.shape({}),
    setGetTypeData: PropTypes.func.isRequired,
    setListingData: PropTypes.func.isRequired
  }).isRequired,
  ProductStore: PropTypes.shape({
    getListingDetails: PropTypes.func.isRequired,
    listingPageNo: PropTypes.number.isRequired,
    type: PropTypes.string.isRequired,
    collectionId: PropTypes.string.isRequired,
    bannerDetails: PropTypes.object.isRequired,
    clearProductData: PropTypes.func.isRequired,
    toggleFilterView: PropTypes.func.isRequired,
    isFetchingData: PropTypes.bool.isRequired,
    getAllProductData: PropTypes.func.isRequired,
    getPageData: PropTypes.func.isRequired,
    setProductData: PropTypes.func.isRequired,
    ProductData: PropTypes.object,
    isHavingMoreProducts: PropTypes.bool,
    toggleMobileFilters: PropTypes.func.isRequired,
    mobileFilterToggle: PropTypes.shape({
      refine: PropTypes.bool.isRequired,
      sortBy: PropTypes.bool.isRequired,
      activeFilter: PropTypes.string.isRequired
    })
  }).isRequired,
  FooterStore: PropTypes.shape({
    changeFooterVisibleState: PropTypes.func.isRequired
  }).isRequired,
  CommonStore: PropTypes.shape({
    isDesktop: PropTypes.bool.isRequired
  }).isRequired
};

const getFinalComponent = component =>
  inject(
    "GetTypeStore",
    "ProductStore",
    "FooterStore",
    "CommonStore"
  )(observer(component));

export const ProjectComponent = {
  getFinalComponent,
  wrapper: Listing.wrappedComponent,
  component: Listing
};

export default ProjectComponent.component;
